/**
* Tabbed FAQs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Tabbed FAQs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'tabbed-faqs',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      getTabContentHeight();
      mobileDropdown();
      $( window ).on( 'resize', function() {
        getTabContentHeight();
        mobileDropdown();
      } );
      let tallestContent = 0;
      function getTabContentHeight() {
        tallestContent = 0;
        $( '.tabbed-faq_content' ).each( function() {
          if ( $( this ).height() > tallestContent ) {
            tallestContent = $( this ).height();
          }
          $( this ).css( 'position', 'absolute' );
        } );
        setTabContentHeight();
      }
      $( '.tabbed-faqs__item' ).on( 'click', function() {
        const thisHeight = $( this ).closest( '.tabbed-faqs_wrapper' ).height( );
        console.log( thisHeight );
        $( this ).closest( '.tabbed-faqs_content-wrapper' ).height( thisHeight+'px' );
      } );
      function setTabContentHeight() {
        $( '.tabbed-faqs_content-wrapper' ).height( tallestContent+'px' );
      }
      function mobileDropdown() {
        if ( window.innerWidth < 768 ) {
          let open = false;
          $( '.tabbed-faqs_mobile-dropdown' ).on( 'click', function() {
            if ( open === false ) {
              $( this ).addClass( 'is-open' );
              open = true;
            } else if ( open === true ) {
              $( '.tabbed-faqs_mobile-dropdown' ).removeClass( 'is-open' );
              open = false;
            }
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'tabbed-faqs', COMPONENT );
} )( app );
